import { MemberProfileEffects } from './member-profile.effects';
import { MemberProfileTravellerEffects } from './member-profile-travellers.effects';
import { MemberProfileSpecialOccasionEffects } from './member-profile-special-occasion.effects';
import { MemberProfileAddressesEffects } from './member-profile-addresses.effects';
import { MemberProfilePhoneNumberEffects } from './member-profile-phone-number.effects';
import { MemberProfilePaymentCardEffects } from './member-profile-payment-cards.effects';

export const effects: any[] = [
  MemberProfileEffects,
  MemberProfileTravellerEffects,
  MemberProfileSpecialOccasionEffects,
  MemberProfileAddressesEffects,
  MemberProfilePhoneNumberEffects,
  MemberProfilePaymentCardEffects,
];

export * from './member-profile.effects';
export * from './member-profile-travellers.effects';
export * from './member-profile-special-occasion.effects';
export * from './member-profile-addresses.effects';
export * from './member-profile-phone-number.effects';
export * from './member-profile-payment-cards.effects';
